export function normalize_id(value) {
  return String(value ?? '').trim();
}

export function get_question_id_candidates(question) {
  return [
    question?.section_question_id,
    question?.form_section_question_id,
    question?.section_question,
    question?.id,
    question?.question_id,
  ];
}

export function get_question_id(question, fallback_id) {
  const found_id = get_question_id_candidates(question)
    .map((value) => normalize_id(value))
    .find(Boolean);
  return found_id || normalize_id(fallback_id);
}

export function get_question_label(question = {}) {
  const label = [
    question?.question_text,
    question?.question,
    question?.text,
    question?.name,
  ]
    .map((value) => String(value || '').trim())
    .find(Boolean);

  return label || '';
}

export function flatten_form_structure(items) {
  const result = [];
  const main_sections = Array.isArray(items) ? items : [];

  main_sections.forEach((main_section, main_index) => {
    const sub_sections = Array.isArray(main_section?.sub_sections) ? main_section.sub_sections : [];

    sub_sections.forEach((sub_section, sub_index) => {
      const questions = Array.isArray(sub_section?.questions) ? sub_section.questions : [];

      questions.forEach((question, question_index) => {
        const label = get_question_label(question);
        if (!label) return;

        result.push({
          id: get_question_id(question, `${main_index}-${sub_index}-${question_index}`),
          label,
        });
      });
    });
  });

  return result;
}

export function build_existing_mappings(items = []) {
  const mappings = {};

  items
    .filter((item) => item?.is_active !== false)
    .forEach((item) => {
      const template_question_id = normalize_id(item?.template_section_question_id);
      const onboarding_question_id = normalize_id(item?.onboarding_section_question_id);

      if (!template_question_id || !onboarding_question_id) return;
      mappings[template_question_id] = onboarding_question_id;
    });

  return mappings;
}

export function build_mapping_payload(mappings = {}) {
  return Object.entries(mappings || {})
    .filter(([, onboarding_question_id]) => Boolean(onboarding_question_id))
    .map(([template_question_id, onboarding_question_id]) => ({
      onboarding_section_question_id: Number(onboarding_question_id),
      template_section_question_id: Number(template_question_id),
      is_active: true,
    }))
    .filter(
      (item) => item.onboarding_section_question_id && item.template_section_question_id,
    );
}

export function create_template_question_mapping_data() {
  return {
    loading: false,
    saving: false,
    loading_existing_mappings: false,
    onboarding_questions: [],
    template_questions: [],
    template_question_mappings: {},
    reload_request_id: 0,
  };
}

const template_question_mapping_computed = {
  selected_template_form_id() {
    return normalize_id(this.$route?.query?.template_form_id);
  },
  selected_template_builder_form_id() {
    return normalize_id(this.$route?.query?.template_builder_form_id);
  },
  selected_onboarding_form_id() {
    return normalize_id(this.$route?.query?.onboarding_form_id);
  },
  selected_form_link_id() {
    return normalize_id(this.$route?.query?.form_link_id);
  },
  resolved_template_form_name() {
    return String(
      this.$route?.query?.template_form_name || 'Template question mapping',
    ).trim();
  },
  resolved_template_form_description() {
    return String(
      this.$route?.query?.template_form_description
      || 'Match each template question to the onboarding question that should populate it.',
    ).trim();
  },
  mapped_questions_count() {
    return this.template_questions.filter((question) =>
      Boolean(this.get_onboarding_selection_for_template(question.id))
    ).length;
  },
};

export default template_question_mapping_computed;
